import * as React from 'react'

// configs
import project from '../../configs/project';

// context
import { useGlobalContext } from '../../context';

// libs
import { createUseStyles } from "react-jss";



const useStyles = createUseStyles({
  message: {
    cursor: 'pointer',
    backgroundColor: 'var(--rs-message-warning-bg)',
    color: 'var(--rs-message-warning-text)',
    padding: '.3rem 1rem',
    transition: 'background-color .1s linear',

    '&:hover': {
      backgroundColor: 'var(--rs-orange-800)',
    }
  },
})


export default function PackageUpdate() {

  // context
  const globalContext = useGlobalContext()

  // styles
  const styles = useStyles();

  // render
  const pkg = globalContext.state.packageVersion
  const needUpdate = pkg.needUpdate

  if (!needUpdate) return null

  return (
    <div className={styles.message} onClick={() => {
      window.open(project.package.npmUrl)
    }}>
      Update {project.name} from version {pkg.current} to {pkg.latest}
    </div>
  )
}